import { useEffect, useState, useContext } from "react";
import LoginAccount from "../../../components/Form/LoginAccount";
import FormComp from "../../../components/Form";
import useFetch from "../../../hooks/useFetch";
import useForm from "../../../hooks/useForm";
import backendRoutes from "../../../utils/backendRoutes";
import { useHistory, useLocation } from "react-router";
import {
  setError,
  setUser,
  User,
} from "../../../state/reducers/authSlice";
import { useAppDispatch } from "../../../hooks/useSelector";
import LoadingScreen from "../../../components/LoadingScreen";
import SessionContext from "../../../contexts/SessionContext";
import ToastContext from "../../../contexts/ToastContext";
import { useStateContext } from "../../../contexts/StateContext";
import { useAuth } from "../../../contexts/AuthContext";

const SignIn = () => {
  const dispatch = useAppDispatch();
  const [loginSuccess, setLoginSuccess] = useState<boolean>(false);
  const { formValues, handleChange } = useForm({ email: "", password: "" });
  const [loginPostData, loginRes, loginErr, isLoading] = useFetch();
  const { goBack, location } = useHistory();

  const { setEmail } = useStateContext();

  // Context
  const { setIsExpired } = useContext(SessionContext);
  const { openError } = useContext(ToastContext);
  const { refreshUser } = useAuth();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail(formValues.email);
    localStorage.setItem("email", formValues.email);
    loginUser(formValues);
  };

  const loginUser = (payload: { [key: string]: string }) => {
    setLoginSuccess(false);
    loginPostData({
      url: backendRoutes.authenticate,
      data: payload,
      method: "POST",
    });
  };

  // The API sets the HttpOnly access_token cookie on this response; the
  // session itself is read back from /api/Account/me. Once it loads,
  // ProtectedAuthRoute moves the user on to ?redirect= (or "/").
  const setLoggedInUser = async (user: User) => {
    setLoginSuccess(true);
    setIsExpired(false);
    dispatch(setUser({ ...user }));
    const sessionUser = await refreshUser();
    if (!sessionUser) {
      setLoginSuccess(false);
      openError("Signed in, but your session could not be started. Please try again.");
    }
  };

  useEffect(() => {
    if (loginRes) {
      if (!loginErr && loginRes?.succeeded) {
        localStorage.setItem("id", loginRes.data.id);
        setLoggedInUser(loginRes.data);
      } else {
        setLoginSuccess(false);
        openError(
          loginErr.response?.data.Message ||
            "An unknown error occured while signing you in",
        );
        dispatch(setError());
      }
    }
  }, [loginRes]);

  return (
    <>
      {/** Added Loading screen */}
      {isLoading && <LoadingScreen />}
      {/* <FormComp
            title="Login"
            textContent=""
            paddingSize="pb-65"
            pageName="Login"
            pageTitle="Login Page"
        > */}
      {loginSuccess}
      <LoginAccount
        formValues={formValues}
        handleChange={handleChange}
        onSubmit={handleSubmit}
        link="/signup"
        loading={isLoading}
        userName={""}
      />
      {/* </FormComp> */}
    </>
  );
};

export default SignIn;
